"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeanDocumentsUploadDialog = exports.DocumentsUploadDialog = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const frontend_infra_localisation_1 = require("@forto-dev/frontend-infra-localisation");
const silhouette_core_1 = require("@freighthub/silhouette-core");
const react_1 = require("react");
const getDocuments_1 = require("../../api/getDocuments");
const EntityDocument_1 = require("../../types/EntityDocument");
const DocumentsUpload_1 = require("./DocumentsUpload");
const DocumentsUploadDialog = (props) => {
    const { data: documentTypes = [] } = (0, getDocuments_1.useDocumentList)();
    return (0, jsx_runtime_1.jsx)(exports.LeanDocumentsUploadDialog, { ...props, documentTypes: documentTypes });
};
exports.DocumentsUploadDialog = DocumentsUploadDialog;
const LeanDocumentsUploadDialog = ({ isSupplier, open, closeDialog, handleError, upload, allowedFormats, documentTypes, }) => {
    const { translate } = (0, frontend_infra_localisation_1.useI18n)();
    const [type, setType] = (0, react_1.useState)('');
    const [typeError, setTypeError] = (0, react_1.useState)(false);
    const [currentDocumentTypes, setCurrentDocumentTypes] = (0, react_1.useState)([]);
    const documentTypeMapper = (docType) => {
        const translation = translate(docType.code);
        return ((0, jsx_runtime_1.jsx)(silhouette_core_1.MenuItem, { value: docType.code, "data-testid": "document-type_menu_item", children: translation === docType.code ? docType.displayName : translation }, docType.code));
    };
    const handleUpload = (file, onProgress) => {
        if (type) {
            return upload(file, onProgress, type);
        }
        setTypeError(true);
    };
    (0, react_1.useEffect)(() => {
        const getCurrentDocTypes = () => documentTypes.filter((documentType) => {
            if (isSupplier) {
                return EntityDocument_1.supplierTypeCodes.includes(documentType.code);
            }
            return documentType.selectors?.tags?.includes('ship');
        });
        if (documentTypes?.length) {
            setCurrentDocumentTypes(getCurrentDocTypes());
        }
    }, [isSupplier, documentTypes, open]);
    return ((0, jsx_runtime_1.jsxs)(silhouette_core_1.Dialog, { open: open, onClose: closeDialog, fullWidth: true, "data-testid": "documents-upload_dialog_box", children: [(0, jsx_runtime_1.jsx)(silhouette_core_1.DialogTitle, { onClose: closeDialog, showClose: true, children: translate('frontend-sdk_upload_document') }), (0, jsx_runtime_1.jsx)(silhouette_core_1.DialogContent, { children: (0, jsx_runtime_1.jsx)(silhouette_core_1.TextField, { value: type, onChange: (e) => {
                        setType(e.target.value);
                    }, label: translate('frontend-sdk_select_file'), helperText: typeError ? translate('frontend-sdk_select_document_type_error') : null, error: typeError, SelectProps: {
                        SelectDisplayProps: {
                            'data-testid': 'select-upload-document_type',
                        },
                    }, margin: "normal", "data-e2e-id": "select-upload-document_type", fullWidth: true, select: true, required: true, children: currentDocumentTypes.map(documentTypeMapper) }) }), !!type && ((0, jsx_runtime_1.jsx)(DocumentsUpload_1.DocumentsUpload, { upload: handleUpload, onAllUploaded: closeDialog, handleError: handleError, allowedFormats: allowedFormats }))] }));
};
exports.LeanDocumentsUploadDialog = LeanDocumentsUploadDialog;
//# sourceMappingURL=DocumentsUploadDialog.js.map